import React from "react";
import classes from "./ActivityAppeal.module.scss";
import tel from "../../../assets/icons/Vector (37).png";
import faks from "../../../assets/icons/Vector (36).png";
import BreadCrumb from "../../../components/BreadCrumb";
import ActivityArbitrageTable from "../../../components/ActivityArbitrageTable";
import { ger, germob } from "../../../assets/db";
import { useFetch } from "../../../hooks/useFetch";
export default function ActivityAppeal() {
  const [loading, data] = useFetch(`/content/all/schedule?lang=en`);
  return (
    <div className={` ${classes.ActivityAppeal} load-anim`}>


      <BreadCrumb
        list={[
          { title: "Bosh sahifa", path: "/" },
          { title: "Faoliyat", path: "/activity" },
          { title: "Fuqarolarning murojatlari", path: "/activity-appeal" },
        ]}
      />

      <div className={`container ${classes.ActivityAppeal_item}`}>
        <h1>Fuqarolarning murojatlari</h1>
        <div className={classes.ActivityAppeal_item_header}>
          <h1 style={{ textAlign: 'center', color: 'blue' }}>
            Jismoniy shaxslar va yuridik shaxslarning vakillarini O‘zbekiston Respublikasi Adliya vazirligi huzuridagi
            “Intellektual mulk markazi” Davlat muassasasi rahbariyati
            tomonidan shaxsiy qabul kunlari
          </h1>
          <h1 style={{ textAlign: 'center' }}>JADVALI</h1>
          {/* <ActivityArbitrageTable left={true} object={ger} object1={germob} /> */}
          <div className={classes.table_container}>
            {data.data && data.data ? (
              <ActivityArbitrageTable left={true} object={data.data} />
            ) : (
              ""
            )}
          </div>
        </div>
        {/* <div className={classes.Vacency_main_middle_right_bottom}>
          <h3>Для получения дополнительной информации, можете позвонить</h3>
          <div className={classes.Vacency_main_middle_right_bottom_child}>
            <img src={faks} />
            <span>
              <h3> Отдел кадров</h3>
              <a href="+998 (71) 232 50 44">+998 (71) 232 50 44</a>
            </span>
          </div>
          <div className={classes.Vacency_main_middle_right_bottom_child}>
            <img src={tel} />
            <span>
              <h3>Факс</h3>
              <a href="+998 (71) 232 50 44">+998 (71) 232 50 44</a>
            </span>
          </div>
          <div className={classes.Vacency_main_middle_right_bottom_child}>
            <img src={faks} />
            <span>
              <h3>Горячая линия</h3>
              <a href="+998 (71) 232 50 44">+998 (71) 232 50 44</a>
            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
}
